import { emptyArray } from '../../../../utils/arrayUtils';
import dayjs from 'dayjs';

export function parseVendorTags(rawTags) {
  if (Array.isArray(rawTags)) {
    return rawTags.filter(Boolean);
  }

  if (typeof rawTags === 'string' && rawTags.trim()) {
    try {
      const parsed = JSON.parse(rawTags);
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch {
      return [];
    }
  }

  return [];
}

export function getCodeDisplayLabel(single) {
  if (typeof single === 'string') return single;
  if (!single || typeof single !== 'object') return 'Not provided';
  return single.code || single.description || single.value || single.id || 'Not provided';
}

export function shouldShowSingleCodeInline(columnValue, values) {
  return (columnValue === 'naics' || columnValue === 'setAsides') && !emptyArray(values) && values.length === 1;
}

export function getSbaCertificationExpirationDate(detail) {
  if (!detail || typeof detail === 'string') return null;

  return (
    detail.expirationDate ||
    detail.expiryDate ||
    detail.certificationExpirationDate ||
    detail.certExpirationDate ||
    detail.endDate ||
    null
  );
}

export function isSbaCertificationExpiringSoon(detail) {
  const expirationDate = getSbaCertificationExpirationDate(detail);

  if (!expirationDate || !dayjs(expirationDate).isValid()) return false;

  const today = dayjs().startOf('day');
  const sixMonthsFromNow = today.add(7, 'month');
  const expiration = dayjs(expirationDate);

  return expiration.diff(today, 'day') >= 0 && sixMonthsFromNow.diff(expiration, 'day') >= 0;
}

export function getSbaCertificationDisplayName(detail) {
  if (typeof detail === 'string') return detail;
  if (!detail || typeof detail !== 'object') return 'Not provided';
  return detail.name || detail.code || 'Not provided';
}

export function getFilterDisplayValue(item) {
  if (item == null) return '';
  if (typeof item === 'string' || typeof item === 'number') return String(item);
  return item.value ?? item.create ?? item.name ?? item.code ?? item.id ?? '';
}
